export default (diceBearsURL) => {
  return `#${diceBearsURL ? diceBearsURL.split("?background=%23")[1].substr(0, 6) : "ffffff"}`;
};
